<i18n>
  {
    "pt_BR": {
      "counter": "carateres a mais | caracter restante | caracteres restantes",
      "title": {
        "label": "Nome da campanha:",
        "placeholder": "Para sua identificação e organização interna"
      },
      "token": {
        "label": "Clique aqui para ser notificado no RD Station quando o seu sms for respondido",
        "placeholder": "Para ser notificado quando o seu sms for respondido (não é obrigatório)"
      },
      "body": {
        "label": "Mensagem:",
        "placeholder": "Escreva uma mensagem para ser enviada por SMS. Ela pode ter até 160 caracteres! Mais que isso, serão enviadas 2 ou mais SMSs para a mesma campanha."
      },
      "vars": {
        "label": "Variáveis",
        "soon": "Variáveis personalizadas [Em breve]"
      },
      "save": "Salvar",
      "created": {
        "title": "Sua campanha foi criada com sucesso. 👌",
        "instructions": "Copie a URL e insira em seu fluxo de automação de marketing.",
        "copy": "Copiar URL",
        "copied": "URL copiada!",
        "action": "Ir para Automação de Marketing RD Station",
        "new": "Criar nova mensagem"
      },
      "edit": {
        "title": "Sua campanha foi editada com sucesso. 👌",
        "new": "Editar mensagem"
      }
    }
  }
</i18n>

<template>
  <section class="new-campaign" v-if="created == null">
    <template v-if="loading">
      Loading...
    </template>

    <template v-else>
      <article class="new-campaign--edit-container">
        <form id="nova-campanha" class="new-campaign--form" @submit.prevent="submit">
        <div style="background:red;color:white;padding: 5px;text-align: center;"><b>Atenção!</b><br/> O SMS será enviado aos leads, somente se o campo CELULAR do RD STATION MARKETING estiver devidamente preenchido com o número de celular. <a href="https://chagbrasil.zendesk.com/hc/pt-br/articles/8452741711373" target="_blank">Saiba mais.</a></div></br>
          <div class="new-campaign-input--container">
            <label for="campaignName" v-t="'title.label'"></label>
            <input id="campaignName" class="new-campaign-input--field" type="text" name="title" maxlength="70" :placeholder="$t('title.placeholder')" v-model="form.title" required />

            <p class="new-campaign-input--error active" :key="message" v-text="message" v-for="message in form.error('title')"></p>
            <p class="new-campaign-input--error" v-if="! form.has('title')"></p>
          </div>

          <div class="new-campaign-input--container">
            <a v-if="!editing" href="https://api.rdsms.com.br/redirect" target="_blank" v-t="'token.label'">
            </a>
          </div>

          <div class="new-campaign-input--container">
            <label for="campaignMessage" v-t="'body.label'"></label>
            <textarea id="campaignMessage" class="new-campaign-input--textarea" type="text" name="body" maxlength="480" :placeholder="$t('body.placeholder')" v-model="form.body" required ref="body"></textarea>
            <div class="new-campaign-input--notices">
              <p class="new-campaign-input--error active" :key="message" v-text="message" v-for="message in form.error('body')"></p>
              <p class="new-campaign-input--error" v-if="! form.has('body')"></p>

              <p id="charCounter" class="new-campaign-input--counter">
                {{ counter.abs }} {{ $tc('counter', counter.normal >= 0 ? counter.min : 0) }}
              </p>
            </div>
          </div>

          <div class="new-campaign-input--container">
            <label for="" v-t="'vars.label'"></label>
            <div class="new-campaign-input--pills">
              <button id="firstName" class="new-campaign-input--pill" type="button" @click.prevent="toggleBody('*|PRIMEIRO_NOME|*')">Primeiro Nome</button>
              <button id="varSoon" class="new-campaign-input--pill button--disabled" type="button" disabled v-t="'vars.soon'"></button>
            </div>
          </div>

          <div class="new-campaign--buttons">
            <input id="campaignSubmit" class="new-campaign--button" type="submit" name="createCampaign" :value="$t('save')">
          </div>
        </form>
        

      </article>

      <preview :body="body" />
    </template>
  </section>

  <section class="created-message" v-else>
    <article class="created-message--card">
      <h3 class="created-message--title" v-text="created.title"></h3>
      <h2 class="created-message--success" v-t="(editing ? 'edit' : 'created') + '.title'"></h2>
      <p class="created-message--text" v-t="'created.instructions'"></p>

      <copy :text="created.url">
        <div class="created-message--url" slot-scope="{ copied }">
          <input class="created-message--input inputCopyUrl" type="text" name="messageTitle" :value="created.url">
          <button class="created-message--copy-url btnCopyUrl" :class="{ active: copied }" v-t="'created.' + (copied ? 'copied' : 'copy')"></button>
        </div>
      </copy>

      <div class="created-message--actions">
        <a class="created-message--goto-rd" target="_blank" href="https://app.rdstation.com.br/automacao-de-marketing/fluxos" v-t="'created.action'"></a>

        <a class="created-message--new-message" @click.prevent="reset" v-t="(editing ? 'edit' : 'created') + '.new'"></a>
      </div>
    </article>
  </section>
</template>


<script>
var url_string = window.location.href;
var url = new URL(url_string);

  import Copy from '@/Copy';
  import Form from 'core/form';
  import Axios from 'core/axios';
  import Preview from './Preview';

  const defaultData = () => ({
    resposta: {
      token: url.searchParams.get("access_token"),
      refresh_token: url.searchParams.get("refresh_token"),
      code:  url.searchParams.get("code"),
    },
    form: Form.from([
      'title', 
      'body', 
      'resposta.token',
      'refresh_token', 
      'code',
    ]),
    id: null,
    loading: false,
    editing: false,
    created: null,
  });

  export default {
    components: {
      Copy,
      Preview,
    },

    props: {
      hash_id: {
        type: String,
      },
      
    },
    mounted: function() {
	     //console.log(this.$route.query);
	     //console.log(this.$route.query.code);
	     //console.log(this.$route.query.access_token);
	     //console.log(this.$route.query.refresh_token);
         
       // code = this.$route.query.code;
        //console.log(name);
	     this.code = this.$route.query.code;
	     this.accessToken = this.$route.query.access_token;
	     this.refreshToken = this.$route.query.refresh_token;
	     
	  },  

    created () {
      if (this.hash_id) {
        this.loading = true;
        this.editing = true;

        return Axios.get('campaign/' + this.hash_id)
          .then(({ data }) => {
            this.form.fill(data.data);
            this.id = data.data.id;

            this.loading = false;
          })
          .catch(() => this.$router.push('/404'));
      }
    },

    data: () => defaultData(),

  
    computed: {
      counter () {
        const counter = 160 - this.body.length;
         
        return {
          normal: counter,
          abs: Math.abs(counter),
          min: Math.max(counter, 1),
        };
      },

      body () {
        return this.form.body.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      },
    },

    methods: {
      reset () {
        const data = defaultData();

        Object.keys(data)
          .forEach((key) => {
            this.$set(this, key, data[key]);
          });
      },

      toggleBody (string) {
        const body = this.form.body;
        const pointer = this.$refs.body.selectionStart;
        const before = body.substring(0, pointer);
        const after = body.substring(pointer, body.length);

        const flag = this.form.body.indexOf(string) === -1;

        this.form.body = flag ? before + string + after : body.replace(string, '');
        this.$refs.body.focus();
      },

      submit () {
        this.save(this.form.run())
          .then(({ data }) => this.created = data.data)
          .catch(err => this.form.update(err));
      },

      save (data) {
       //Inicio da Solução 
       data.code = this.$route.query.code;
       data.token = this.$route.query.access_token;
       data.refresh_token = this.$route.query.refresh_token;
        if (this.id) {
          return Axios.put('campaign/' + this.id, data);
        }

        return Axios.post('campaign', data)
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/Campaign/Form.vue